<template>
	<div class="swimOrder">
		<back-to></back-to>
		<section class="swimOrder_top">
			<div class="swimOrder_top-pay" v-if="localOrderStatus == 0">{{statusTexts[objects.orderStatus]}}/待支付</div>
			<div class="swimOrder_top-pay" v-if="localOrderStatus == 1">{{statusTexts[objects.orderStatus]}}</div>
			<div class="person_title">
				<h2>{{objects.name}}</h2>
				<img :src="objects.picturePath" alt="">
			</div>
		</section>
		<section class="person_origin">
			<span><label for="">套餐</label>
				<p>{{objects.package}}</p>
			</span>
			<span><label for="">团期</label>
				<p>{{objects.planTime}}</p>
			</span>
			<span><label for="">出发地</label>
				<p>{{objects.pod}}</p>
			</span>
			<span><label for="">目的地</label>
				<p>{{objects.destination}}</p>
			</span>
			<span><label for="">数量</label>
				<p>{{objects.number}}</p>
			</span>
		</section>
		<section class="info">
			<h2>订单信息</h2>
			<div class="person_origin">
				<span><label for="">下单时间</label>
					<p>{{objects.createTime | formateDate}}</p>
				</span>
				<span><label for="">订单id</label>
					<p>{{objects.orderCode}}</p>
				</span>
			</div>
		</section>
		<section class="info">
			<h2>预定人信息</h2>
			<div class="person_origin">
				<span><label for="">联系人</label>
					<p>{{objects.contactName}}</p>
				</span>
				<span><label for="">联系电话</label>
					<p>{{objects.contactTel}}</p>
				</span>
			</div>
		</section>
		<section class="info">
			<h2>出行人信息</h2>
			<span class="person_chuxing-content">
				<section v-for="(item,index) in objects.guests" :key="index">
					<label>
						<p>{{item.enrollName}}</p>
						<font>{{item.cnName}}</font>
					</label>
				</section>
			</span>
		</section>
		<!-- 出团按钮 -->
		<section class="foot" v-if="haveNotice">
			<!-- <div class="btn" @click="getNoticeInfo">出团通知</div> -->
			<div class="btn btn-red" v-if="localOrderStatus == 0" @click="pay">支付</div>
			<div class="btn" v-if="localOrderStatus == 1"> 已支付 </div>
		</section>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import {
		Toast
	} from 'vant'
	import BackTo from "@/components/BackTo";
	import {
		formateDate
	} from '@/config/util'
	import {
		_throttle
	} from '@/config/util'
	import * as jweixin from 'weixin-js-sdk'
	export default {
		name: 'swimOrder',
		components: {
			BackTo
		},
		data() {
			return {
				localOrderStatus: 0,
				localOrderID: 0,
				wxOrderNumber: '',
				statusTexts: [
					'',
					'补充资料',
					'',
					'待出行',
					'出行中',
					'待评价',
					'订单完成',
					'未确认',
					'签署合同',
					'作废订单',
					'确认订单'
				],
				objects: "",
				haveNotice: true,
				noticeObject: null
			}
		},
		filters: {
			formateDate(time) {
				let date = new Date(time)
				return formateDate(date)
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		created() {

		},
		mounted() {
			this.getOrderList()
			this.getOrderInfo()
		},
		methods: {
			getNoticeInfo() {
				// that.data.noticeObject.url
				// 预览文档
			},

			pay: _throttle(function() {
				const toast = Toast.loading({
					duration: 0, // 持续展示 toast
					forbidClick: true,
					message: '支付中',
				});

				// let second = 2;
				// const timer = setInterval(() => {
				// 	second--;
				// 	if (second) {
				// 		toast.message = '成功';
				// 	} else {
				// 		clearInterval(timer);
				// 		// 手动清除 Toast
				// 		Toast.clear();
				// 		this.$router.back()
				// 	}
				// }, 1000);
				var data = {
					"id": Number(this.localOrderID),
					"openId": this.userInfo.openid
				}
				this.$_postNew(
					this.$severOrder + "/TeamPay/TeamAppletPay", data
				).then(res => {
					Toast.clear();
					console.log(res.result)
					var data = {
						"orderId": Number(this.objects.id),
						"openId": this.userInfo.openid
					}
					this.$_postNew(
						this.$apiNearTravel + "/api/services/app/Order/TCPayAsync", data
					).then(res => {
						Toast.clear();
						console.log(res.result)
						this.wxPay(res.result.data)
					})
				})
			}, 3000),
			// 凋起支付
			wxPay(e) {
				var _this = this
				jweixin.config({
					debug: false, // 关闭调试
					appId: e.appId,
					timestamp: e.timeStamp,
					nonceStr: e.nonceStr,
					signature: e.paySign,
					jsApiList: [
						'chooseWXPay'
					]
				});
				jweixin.ready(function() {
					jweixin.chooseWXPay({
						timestamp: e.timestamp,
						nonceStr: e.nonceStr,
						package: e.package,
						paySign: e.paySign,
						signType: e.signType,
						success: res => {
							_this.getOrderInfo()
						},
						cencel: res => {
							Toast('取消支付');
						},
						fail: err => {
							Toast('支付失败');
						}
					});
				})

			},
			getOrderList() {
				var jsonData = {}
				this.$_post(
					this.$connectHttpSweet + '/TeamAll/GetOrderIdByOrderCode?OrderCode=' + this.$route.query.orderId,
					jsonData
				).then(res => {
					this.localOrderID = res.result.item1
					this.localOrderStatus = res.result.item2
					this.wxOrderNumber = res.result.item3
				})
			},
			getOrderInfo() {
				var jsonData = {
					orderCode: this.$route.query.orderId,
					key: this.$md5(this.$route.query.orderId + "|@Sweet0ur2016-@Sweet0ur2024")
				}
				this.$_post(
					this.$connectHttpDayun + '/orderquery/get/api/mobileorder', jsonData
				).then(res => {
					this.objects = res.object
					// this.getNotice()
				})
			},
			getNotice() {
				var jsonData = {
					id: this.objects.planID
				}
				this.$_post(
					this.$connectHttpDayun + '/teamquery/get/api/get', jsonData
				).then(res => {
					if (res.isSuccess) {
						//有出团通知
						this.noticeObject = res.object
						this.haveNotice = true
					}
				})
			}
		}
	}
</script>

<style scoped>
	.swimOrder_top {
		width: 100%;

	}

	.swimOrder_top-pay {
		height: 80px;
		background: #ffeee2;
		color: #ff6d00;
		line-height: 80px;
		text-align: center;
		font-size: 28px;
	}

	.person_title {
		display: flex;
		width: 100%;
		height: 184px;
		background-color: #f6f6f6;
		align-items: flex-start;
		justify-content: space-between;
		padding: 32px;
		box-sizing: border-box;
	}

	.person_title h2 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		font-weight: normal;
		font-size: 30px;
	}

	.person_title img {
		border-radius: 5px;
		width: 120px;
		height: 120px;
	}

	.person_origin {
		width: 100%;
		padding: 32px 32px 0 32px;
		box-sizing: border-box;
	}

	.person_origin span {
		width: 100%;
		display: flex;
		margin-bottom: 32px;
	}

	.person_origin label {
		width: 168px;
		font-size: 24px;

		color: #999;
	}

	.person_origin p {
		font-size: 24px;
		color: #333;
	}

	.info {
		border-top: 20px solid #f7f7f7;

	}

	.info h2 {
		font-size: 28px;
		width: 100%;
		padding: 32px 32px 20px 32px;
		box-sizing: border-box;
	}

	.person_chuxing-content {
		width: 100%;

	}

	.person_chuxing-content section {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		padding: 0 32px;
		box-sizing: border-box;
	}

	.person_chuxing-content label {
		display: flex;
		flex-direction: row;
		margin-right: 16px;
		margin-top: 16px;
	}

	.person_chuxing-content p {
		padding-left: 16px;
		padding-right: 16px;
		line-height: 40px;
		font-size: 24px;
		color: #fff;
		background-color: #333;
		border-top-left-radius: 5px;
		border-bottom-left-radius: 5px;
		border: 1px solid #333;
	}

	.person_chuxing-content font {
		padding-left: 16px;
		padding-right: 16px;
		line-height: 40px;
		font-size: 24px;
		background-color: #fff;
		color: #333;
		border-top-right-radius: 5px;
		border-bottom-right-radius: 5px;
		border: 1px solid #333;
	}

	.foot {
		background-color: #fff;
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 120px;
		display: flex;
		z-index: 10;
		background: #ffffff;
		align-items: center;
		justify-content: flex-end;
		padding: 0 32px;
		box-shadow: 1px -5px 10px #eee;
		box-sizing: border-box;

	}

	.btn {
		margin-left: 30px;
		height: 60px;
		line-height: 60px;
		padding-left: 32px;
		padding-right: 32px;
		color: #333;
		font-size: 24px;
		border: 1px solid #ccc;
		border-radius: 10px;
	}

	.btn-red {
		color: #ff6d00;
		border: 1px solid #ff6d00;
	}
</style>